<template>
  <div>

    <!--title start-->
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>{{ $t("datasystem") }}</h4>
        </div>
      </div>
    </div>

    <div class="grab h4wrap">
      <div class="border_dashed_b mt_30">
        <h5 class="h5_title">{{ $t("datasystem_1_title") }} </h5>
        <ul class="ul_list">
          <li>{{ $t("datasystem_1_detail") }}</li>
        </ul>
        <button class="location_btn" style="margin-left: 24px; margin-top: 16px" onclick="window.open('http://61.77.90.37:50/wise/index.html')">{{ $t("gotosite") }}</button>
      </div>
      <div class="border_dashed_b mt_30">
        <h5 class="h5_title">{{ $t("datasystem_2_title") }}</h5>
        <ul class="ul_list">
          <li>{{ $t("datasystem_2_detail") }}</li>
        </ul>
        <button class="location_btn" style="margin-left: 24px; margin-top: 16px" onclick="window.open('http://61.77.90.37:50/rwis/index.html')">{{ $t("gotosite") }}</button>
      </div>
      <div class="border_dashed_b mt_30">
        <h5 class="h5_title">{{ $t("datasystem_3_title") }} </h5>
        <ul class="ul_list">
          <li>{{ $t("datasystem_3_detail") }}</li>
        </ul>
        <button class="location_btn" style="margin-left: 24px; margin-top: 16px" onclick="window.open('http://61.77.90.148:8090/#/')">{{ $t("gotosite") }}</button>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'DataSystem'
  }
</script>



// WEBPACK FOOTER //
// src/components/DataSystem.vue